import { approxTextMeasurer, defaultTextLayoutContext, layoutTextBlock, normRectWidthPx, DEFAULT_SLIDE_HEIGHT_PX, } from "./textLayout.js";
export { DEFAULT_SLIDE_HEIGHT_PX, approxTextMeasurer, defaultTextLayoutContext };
/** Estimate normalized text block height using the shared line-breaking engine. */
export function estimateTextBlockHeight(text, rectW, sizeRel, lineHeight, maxLines, layout = defaultTextLayoutContext(), fontFamily = "Surf Sans", fontWeight = 400) {
    if (!text.trim())
        return 0;
    const fontSizePx = sizeRel * layout.slideHeightPx;
    const maxWidthPx = normRectWidthPx(rectW, layout.slideHeightPx);
    const { heightPx } = layoutTextBlock(text, maxWidthPx, layout.measurer, fontFamily, fontWeight, fontSizePx, lineHeight, { maxLines });
    return heightPx / layout.slideHeightPx;
}
/** Binary-search shrink sizeRel until text fits rect.h. */
export function fitTextSizeRel(text, rect, baseSizeRel, lineHeight, maxLines, layout, fontFamily = "Surf Sans", fontWeight = 400) {
    if (!text.trim())
        return baseSizeRel;
    const ctx = layout ?? defaultTextLayoutContext();
    const min = baseSizeRel * 0.35;
    let lo = min;
    let hi = baseSizeRel;
    for (let i = 0; i < 14; i += 1) {
        const mid = (lo + hi) / 2;
        const fontSizePx = mid * ctx.slideHeightPx;
        const maxWidthPx = normRectWidthPx(rect.w, ctx.slideHeightPx);
        const { heightPx } = layoutTextBlock(text, maxWidthPx, ctx.measurer, fontFamily, fontWeight, fontSizePx, lineHeight, { maxLines });
        const hNorm = heightPx / ctx.slideHeightPx;
        if (hNorm <= rect.h)
            lo = mid;
        else
            hi = mid;
    }
    return lo;
}
